import { useContext } from 'react';

import { SsrApiDataContext } from './SsrApiDataContext';

export function useSsrApiData<TData>(
  url: string | undefined,
): TData | undefined {
  const dataByUrl = useContext(SsrApiDataContext);

  if (!url) return undefined;
  return dataByUrl[url] as TData;
}
